import { useMsal } from "@azure/msal-react";

/**
 * Hook that provides auth state from MSAL 
 * Compatible with the old useAuthProvider interface for easy drop-in
 */
export function useMsalAuth() {
  const { instance, accounts, inProgress } = useMsal();
  
  // User is signed in if we have accounts
  const isSignedIn = accounts.length > 0;
  
  // Consider loaded once we've reached a definitive state
  const isLoaded = inProgress !== "startup";
  
  // Get user info from the first account (or null)
  const user = accounts[0] ? {
    id: accounts[0].localAccountId,
    fullName: accounts[0].name || "",
    firstName: accounts[0].name?.split(' ')[0] || "",
    lastName: accounts[0].name?.split(' ').slice(1).join(' ') || "",
    emailAddresses: [{ emailAddress: accounts[0].username }],
    primaryEmailAddress: { emailAddress: accounts[0].username },
    imageUrl: "",
    username: accounts[0].username,
  } : null;
  
  return {
    user,
    isLoaded,
    isSignedIn,
    error: null,
  };
}